import { Button } from "@devhop/ui";
import { HelpCircleIcon, PlusIcon } from "lucide-react";

type CollectionsToolbarProps = {
  canManage: boolean;
  onCreate: () => void;
  onStartTour?: () => void;
};

export function CollectionsToolbar({
  canManage,
  onCreate,
  onStartTour,
}: CollectionsToolbarProps) {
  return (
    <div className="mb-2 flex flex-col gap-4">
      <div className="flex flex-wrap items-center justify-between space-y-2">
        <div>
          <h2 className="flex items-center font-bold text-2xl tracking-tight">
            Collections{" "}
            {onStartTour && (
              <Button
                variant="ghost"
                size="icon"
                onClick={onStartTour}
                className="ml-2 size-6"
                title="ເລີ່ມທົດລອງການນຳທາງ"
              >
                <HelpCircleIcon className="h-4 w-4" />
              </Button>
            )}
          </h2>
          <p className="text-muted-foreground">ຈັດການ Collection ຂອງສິນຄ້າ</p>
        </div>
        <div
          className="flex items-center gap-2"
          data-tourid="catalog-collections-toolbar"
        >
          {canManage && (
            <Button onClick={onCreate}>
              <PlusIcon className="h-4 w-4" />
              ສ້າງ Collection
            </Button>
          )}
        </div>
      </div>
    </div>
  );
}
